// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__kRV37","title":"card_title__Il9sN","inActive":"card_inActive__1dNcl"};